import { tss } from 'tss-react/mui';

import { REPORTS_COLORS } from '@/constants/chartcolors.constants';

const useStyles = tss.create(({ theme }) => ({
  avgAckTimeBox: {
    height: 50,
    width: 75,
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderRadius: 6,
    color: theme.vars.palette.common.white,
    fontWeight: 'bold'
  },
  chip: {
    borderRadius: 6,
    marginRight: theme.spacing(0.5)
  },
  execDonutChartContainer: {
    height: 200,
    '& [class*="donutChartWrapper"]': {
      marginTop: '-12px !important',
      position: 'relative',
      zIndex: 0
    }
  },
  execFunnelListItems: {
    display: 'list-item',
    padding: '0px',
    lineHeight: 1.3,
    marginBottom: 0
  },
  insightsText: {
    height: '375px',
    overflow: 'hidden',
    gap: theme.spacing(2),
    fontSize: '12px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    '& > *': {
      marginBlockStart: '0.25rem',
      marginBlockEnd: '0.25rem'
    },
    '& ul': {
      paddingInlineStart: '16px !important',
      '@media print': {
        paddingInlineStart: '16px !important' // Even more space for print
      }
    },
    '& li': {
      paddingInlineStart: '4px !important',
      marginLeft: '0px',
      '@media print': {
        paddingInlineStart: '6px !important' // More space for print
      }
    },
    '& li ul': {
      marginBottom: '0.5rem'
    },
    '& h4': {
      fontSize: '1.05em'
    }
  },
  insightsTextContainer: {
    flexWrap: 'wrap',
    height: '400px'
  },
  metricsArrowText: {
    color: 'white',
    fontWeight: 'bold',
    fontSize: '12px'
  },
  metricsArrowBox: {
    height: '16px',
    borderRadius: '5px',
    alignContent: 'center',
    display: 'flex',
    justifyContent: 'center'
  },
  metricsArrow: {
    marginLeft: '-28px'
  },
  metricsCard: {
    backgroundColor: 'white',
    color: 'black',
    width: '16%'
  },
  metricsCardContent: {
    padding: theme.spacing(1)
  },
  metricsCardHeader: {
    color: 'white',
    padding: theme.spacing(1),
    '& .MuiTypography-root': {
      fontSize: '0.70rem'
    }
  },
  metricsTableContainer: {
    height: '280px',
    width: '100%',
    '& .ag-spanned-cell-wrapper': {
      height: '100px !important',
      width: '50px !important'
    },
    '& .ag-cell': {
      border: '' // Remove default cell borders
    }
  },
  reportsPageContainer: {
    // Container for the entire page that adds spacing between elements
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2)
  },
  serviceTicketColumn: {
    width: 'calc(50% - 21px)'
  },
  threatTicketsBannerTitleText: {
    fontSize: '12px',
    color: theme.vars.palette.primary.main,
    textTransform: 'uppercase',
    lineHeight: 1
  },
  threatTicketsBannerNumberText: {
    fontSize: '52px',
    fontWeight: 900,
    color: theme.vars.palette.primary.main,
    textTransform: 'uppercase',
    lineHeight: 1
  },
  threatTicketsBannerChangeText: {
    fontSize: '12px',
    color: theme.vars.palette.primary.main,
    lineHeight: 1
  },
  threatTicketsSmallColumn: {
    height: 730,
    '@media print': {
      height: 740
    }
  },
  totalCasesText: {
    fontSize: '36px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: REPORTS_COLORS.CASES
  },
  totalEventsText: {
    fontSize: '36px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    color: REPORTS_COLORS.EVENTS
  },
  reportsPreviewSubTitle: {
    borderBottom: '0px',
    padding: '0 !important',
    minHeight: '12px',
    textTransform: 'uppercase',
    fontSize: '14px',
    fontWeight: '600 !important',
    lineHeight: '1rem',
    marginBottom: theme.spacing(0.5)
  },
  reportsChartContainer: {
    paddingBottom: theme.spacing(3)
  }
}));

export default useStyles;
